import React, { Component } from "react";
import bunzlLogo from "../assets/images/bunzl-logo.gif";
import infologo from "../assets/images/information.png";
import authenticationService from "../_services/authentication.services";
import "../assets/css/login.css";
import { authHeader, encodedURL } from "../_helpers/auth-header";
import { withRouter } from "react-router-dom";
import r3Logo from "../assets/images/r3-logo.gif";
import appConstants from "../_services/applicationConstant";
import { styles } from "../assets/css/bunzlUI.css";
import ESSModal from "../components/ESSModal.jsx";
import Modal from "react-bootstrap/Modal";
import api from "../_services/apiUrl.js";
import { useVersionCheck } from "../components/UseVersionCheck.jsx";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCompanyField: true,
      txtUserName: "",
      txtPassword: "",
      txtCompanyNumber: "",
      txtOTP: "",
      logintype: "C",
      showLoginBox: false,
      version: require("../../package.json").version,
      userMessage: "",
      ssoFlag: "0",
      value: '',
      showOTPModal: false,
      showResendOTPLink: false,
      showOTPSubmit: true,
      timeLeft: 300, // 5 minutes in seconds
      expired: false,
      isMaxAttemptReached: false,
      isMaxInvalidOTPReached: false,
      initialAttempts : false,
      loader: false,
    };

    this.timer = null;
    this.Auth = new authenticationService();
    this.submit = this.submit.bind(this);
  }

  myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;
    var  old= this.state.logintype;
    if (val == "Customer Group") {
      this.state.logintype = "G";
      this.state.txtCompanyNumber = "0";
    } else if (val == "Employee") {
      this.state.logintype = "E";
      this.state.txtCompanyNumber = "0";
    } else if (val == "Customer") {
      this.state.logintype = "C";
    }
    if (nam == "logintype") {

      console.log(old,this.state.logintype)
      if (old != this.state.logintype )
      {
        //this.setState({ txtCompanyNumber: "" });
        this.setState({ txtUserName: "" });
        this.setState({ txtPassword: "" });
      }
      if (val == "Customer Group" || val == "Employee") {
        this.setState({ showCompanyField: false });
      } else {
        this.setState({ showCompanyField: true });
      }
    } else {
      this.setState({ [nam]: val });
    }
  };



  myChangeHandlerForCust = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    
    //   if(nam === "txtUserName" && this.state.logintype === "C")
    //   {
    //     console.log(val)
    //   const regex = /^(?=.{1,15}$)[A-Za-z0-9]+-[A-Za-z0-9]{2}$/;
    //   if (regex.test(val)) {
    //     console.log("Valid format");
    //     this.setState({ [nam]: val });
    //   } 
    //   else{
    //     this.setState({ [nam]: '' });
    //     this.setState({ showLoginBox: true, userMessage: 'Please eneter the userid in below format\n\n1. UserId \n2. Followed by a dash - \n3. Followed by 2 characters suffix' })
    //   }
    // }
  };


  componentDidMount() {

    useVersionCheck();

    let url = window.location.href;
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let sharedsecret = params.get('sharedsecret');
    let loginType = params.get('loginType');
    let customer = params.get('customer');
    let userId = null;
    let compnayNumber = null


    if (url.includes("SelfService/Login.html")) {
      {
        this.props.history.push({
          pathname: "/Login",
        });
      }

    }


    if (customer != null) {
      compnayNumber = customer.substring(0, 2);
      userId = customer.substring(2, customer.length);
    }

    fetch(url, {
      method: 'GET', headers: new Headers({
        'Content-Type': 'application/json',
      })
    })

      .then((res) => {



        if (sharedsecret != null) {
          if (loginType == "customer") {
            this.setState({ logintype: "C" });
          }
          else if (loginType == "customergroup") {
            this.setState({ logintype: "G" });
          }
          else if (loginType == "employee") {
            this.setState({ logintype: "E" });
          }



          document.getElementById("loginDiv").style.display = "none";
          return this.Auth.login(
            userId,
            '',
            compnayNumber,
            this.state.logintype,
            sharedsecret
          )
            .then((res) => {


              //this.props.setSessionStateFunc("true");

              if (this.state.logintype === "G") {
                this.props.history.push({
                  pathname: "/CustomerList",
                });
              } else if (this.state.logintype === "E") {
                this.props.history.push({
                  pathname: "/EmployeeList",
                });
              } else {
                this.props.history.push({
                  pathname: "/Home",
                });
              }

            })
            .catch((err) => {
              window.location = "./SSOModal";
            });
        }
      })
      .catch(function (err) {
        console.info(err + " url: " + url);
      });


  }

  componentWillUnmount() {
    clearInterval(this.timer);
    clearInterval(this.loader);
  }

  startTimer = () => {
    // if (this.timer !== null) return; // already running
    if (this.timer) {
      clearInterval(this.timer); // stop previous one
    }
    

    // this.startTimer();
    
    this.timer = setInterval(() => {
      const { timeLeft } = this.state;
      if (timeLeft > 1) {
        this.setState({ timeLeft: timeLeft - 1 });
      } else {
        clearInterval(this.timer);
        this.setState({ timeLeft: 0, expired: true });
      }
    }, 1100);
  };


  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(0, object.target.maxLength)
    }
  }

  handleClose = () => this.setState({ showLoginBox: false });
  handleOTPButtonClick = () => {
    this.setState({ loader: false });
    this.setState({ showOTPModal: false })
    this.setState({ txtOTP: "" })
    clearInterval(this.timer);
    // clearInterval(this.loader);
    this.setState({ timeLeft: 0, expired: true });
  };

  cancleLogin = () => {
    this.setState({
      ...this.state,
      txtPassword: "",
      txtUserName: "",
      txtCompanyNumber: "",
    });
  };



  sendOTP = (flag) => {

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1; // Months are 0-indexed
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    const formatted = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const formattedExpiry = `${year}-${month}-${day} ${hours}:${minutes + 5}:${seconds}`;


    localStorage.setItem('invalidOTPAttemtsReached', 0);
    if ( this.state.txtUserName != localStorage.getItem('userName' ) && localStorage.getItem('userName') !== null  ){
      localStorage.setItem('OTPAttemtsReached', parseInt(0));
    }else if(flag && this.state.txtUserName != localStorage.getItem('userName'))
    {
      localStorage.setItem('OTPAttemtsReached', parseInt(0));
    }
    
    if (  this.state.txtUserName == localStorage.getItem('userName') && parseInt(localStorage.getItem('OTPAttemtsReached')) >= 3 && formatted > localStorage.getItem('OTPExpiredOn') ) {
      localStorage.setItem('OTPExpiredOn', formattedExpiry);
      localStorage.setItem('OTPAttemtsReached', 0);
      localStorage.setItem('initialAttemptsReached',0);
      localStorage.setItem('InitialAttemptExpiredOn',formattedExpiry);
    } 

    if (  this.state.txtUserName == localStorage.getItem('userName') && parseInt(localStorage.getItem('OTPAttemtsReached')) >= 3 && formatted < localStorage.getItem('OTPExpiredOn') ) {
      this.setState({ isMaxAttemptReached: true });
      return false;
    } else if(flag ){
    if ( localStorage.getItem('OTPAttemtsReached') !== null ) {
      
      localStorage.setItem('OTPAttemtsReached', parseInt(localStorage.getItem('OTPAttemtsReached')) + 1);
    } else if (localStorage.getItem('OTPAttemtsReached') == null) {
      localStorage.setItem('OTPAttemtsReached', parseInt(1));
    }else if(parseInt(localStorage.getItem('OTPAttemtsReached')) >= 3 && formatted > localStorage.getItem('OTPExpiredOn') )
      {
        localStorage.setItem('OTPAttemtsReached', parseInt(1));
      }

    const oldDate = new Date(localStorage.getItem('OTPExpiredOn'));
    const oldDay = oldDate.getDate();
    const oldHours = oldDate.getHours();
    const oldMinutes = oldDate.getMinutes();
    const oldSeconds = oldDate.getSeconds();
      this.isMaxInvalidOTPReached = true;
    const formattedMaxAttemptExpiry = `${year}-${month}-${oldDay} ${oldHours}:${oldMinutes + 300}:${oldSeconds}`;


      localStorage.setItem('OTPSent', true);
      localStorage.setItem('OTPSentOn', formatted);
      localStorage.setItem('OTPExpired', false);
      localStorage.setItem('OTPExpiredOn', formattedExpiry);
      this.setState({ showOTPSubmit: false });
      this.setState({ showResendOTPLink: true });
      this.setState({ expired: false });
      this.setState({ timeLeft: 300 });
      this.setState({ isMaxAttemptReached: false });
      this.setState({isMaxInvalidOTPReached : false });
      this.startTimer();
     
      return true;
    }
  
   
    return true;
  }

  optLimit = () => {
    if(localStorage.getItem('invalidOTPAttemtsReached') == null){
      localStorage.setItem('invalidOTPAttemtsReached',1);
      return true;
    }else if( parseInt(localStorage.getItem('invalidOTPAttemtsReached') >= 3 ))
      {
        this.isMaxInvalidOTPReached = true;
        return false;
      } 
      else{
        localStorage.setItem('invalidOTPAttemtsReached', parseInt(localStorage.getItem('invalidOTPAttemtsReached')) + 1);
        return true;
      }

  }

initialAttemptsFun = () => {


    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1; // Months are 0-indexed
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();

    const formatted = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const formattedExpiry = `${year}-${month}-${day} ${hours}:${minutes + 5}:${seconds}`;

    if( localStorage.getItem('initialAttemptsReached' ) == null && localStorage.getItem('initialAttemptsReached') >= 5  &&  formatted < localStorage.getItem('InitialAttemptExpiredOn'))
      {
      localStorage.setItem('InitialAttemptExpiredOn',formattedExpiry)
      localStorage.setItem('initialAttemptsReached', 1);
        return true;
      }
    
    if(localStorage.getItem('initialAttemptsReached' ) == null)
    {
     
      localStorage.setItem('InitialAttemptExpiredOn',formattedExpiry)
      localStorage.setItem('initialAttemptsReached', 1);
      return true;
    }
   else if( localStorage.getItem('initialAttemptsReached') >= 5  &&  formatted > localStorage.getItem('InitialAttemptExpiredOn'))
      {
      localStorage.setItem('InitialAttemptExpiredOn',formattedExpiry)
      localStorage.setItem('initialAttemptsReached', 1);
        return true;
      }
    else if( localStorage.getItem('initialAttemptsReached') >= 5)
    {
      this.setState({ loader: false });
      return false;
    } else {
      localStorage.setItem('InitialAttemptExpiredOn',formattedExpiry)
      localStorage.setItem('initialAttemptsReached', parseInt(localStorage.getItem('initialAttemptsReached')) + 1);
      return true;
    }
}

  validateOTP = (e) => {
    
    e.preventDefault();
    var flag = this.optLimit();
    if(flag)
    {
      this.setState({ loader: true });
      if(this.state.logintype === "C")
        var user =this.state.txtCompanyNumber+this.state.txtUserName;
        else
        var user = this.state.txtUserName;
        this.Auth.validateOtpSubmitNew(
          
          user,
          this.state.txtOTP
        )
          .then((res) => {

           
            if (res.ReturnCode == 10) 
              {
                this.setState({ showOTPModal: true });
                if( localStorage.getItem('invalidOTPAttemtsReached') >= 3 )
                  {
                    this.setState({ showOTPModal: false });
                    this.setState({ showLoginBox: true, userMessage: 'Maximum attempts reached for invalid otp try after 5 Minutes' })
                  } else
                this.setState({ showLoginBox: true, userMessage: 'Invalid OTP' })
               
              }else if (res.ReturnCode == 20) {
                this.setState({ showOTPModal: true });
                if( localStorage.getItem('invalidOTPAttemtsReached') >= 3 )
                  {
                    this.setState({ showOTPModal: false });
                    this.setState({ showLoginBox: true, userMessage: 'Maximum attempts reached for invalid otp try after 5 Minutes' })
                  } else
                this.setState({ showLoginBox: true, userMessage: 'OTP Expired' })
                
              }else if ( res.ReturnCode == 0) {
    
              
                this.props.setSessionStateFunc("true");

                if (this.state.logintype === "G") {
                  this.props.history.push({
                    pathname: "/CustomerList",
                  });

                } else if (this.state.logintype === "E") {
                  this.props.history.push({
                    pathname: "/EmployeeList",
                  });
                } else {
                  this.Auth.getCustomerLocation().then(()=>{
                    this.Auth.getCustomerAddress().then(() =>{
                  this.props.history.push({
                    pathname: "/Home",
                  })
                });
                });
                }
              
              
                
              this.setState({ showOTPModal: false });
              clearInterval(this.timer);
              this.setState({ timeLeft: 0, expired: true });
            }
            else {
               this.setState({ showOTPModal: true });
               if( localStorage.getItem('invalidOTPAttemtsReached') >= 3 )
                {
                  this.setState({ showOTPModal: false });
                  this.setState({ showLoginBox: true, userMessage: 'Maximum attempts reached for invalid otp try after 5 Minutes' })
                }else
              this.setState({ showLoginBox: true, userMessage: 'Invalid OTP' })
            }
            setInterval(() => {
              this.setState({ loader: false });
            }, 5000);
          })
          .catch((err) => {
            this.setState({ loader: false });
             this.setState({ showOTPModal: true });
             if( localStorage.getItem('invalidOTPAttemtsReached') >= 3 )
              {
                this.setState({ showOTPModal: false });
                this.setState({ showLoginBox: true, userMessage: 'Maximum attempts reached for invalid otp try after 5 Minutes.' })
                this.setState({ loader: false });
              }else
            this.setState({ showLoginBox: true, userMessage: 'Invalid OTP' })
          })
          .finally(() => {
            // setInterval(() => {
            //   this.setState({ loader: false });
            // }, 2000);
          });
        
    }else{
      this.setState({ loader: false });
      this.setState({ showOTPModal: false });
      this.setState({ showLoginBox: true, userMessage: 'Maximum attempts reached for invalid otp try after 5 Minutes.' })
    }
   
    this.setState({txtOTP : ""});
    
  }


   formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  submit(e) {
    e.preventDefault();
    

    this.setState({ loader: true });
    var otp = this.sendOTP(false);
    var initial = this.initialAttemptsFun();
    if (otp && initial) {

      this.Auth.loginSubmit(
        this.state.txtUserName,
        this.state.txtPassword,
        this.state.txtCompanyNumber,
        this.state.logintype,
        this.state.ssoFlag
      )
        .then((res) => {

          if (res.Message !== "An error has occurred.") {
            


            if (res.ReturnCode == "60") {
              this.setState({ loader: false });
              this.setState({ showOTPModal: false });
              if (this.state.logintype === "G")
                this.setState({ showLoginBox: true, userMessage: 'Inactive Customer group.' });
              else if (this.state.logintype === "E")
                this.setState({ showLoginBox: true, userMessage: 'Inactive Employee.' });
              else
                this.setState({ showLoginBox: true, userMessage: 'Inactive Customer.' });

            } else if (res.ReturnCode == "70") {
              this.setState({ loader: false });
              this.setState({ showOTPModal: false });
              this.setState({ showLoginBox: true, userMessage: 'Email Address is not present, connect with Help desk.' })
            } else if (res.ReturnCode == "80") {
              this.setState({ showOTPModal: false });
              this.setState({ showLoginBox: true, userMessage: 'Userid/password combination is invalid.' })
            }else if (res.ReturnCode == "30") {
              this.setState({ loader: false });
              this.setState({ showOTPModal: false });
              this.setState({ showLoginBox: true, userMessage: 'Company number not valid for login account.' })
            }
            else if ( res.ReturnCode == "10" || res.ReturnCode == "20"  || res.ReturnCode == "40" || res.ReturnCode == "50") {
              this.setState({ loader: false });
              this.setState({ showOTPModal: false });
              this.setState({ showLoginBox: true, userMessage: 'Userid/password combination is invalid.' })
            }
            else if (this.state.logintype == "G") {
              this.props.setSessionStateFunc("true");

              this.setState({ initialAttempts: false });
              this.props.history.push({
                pathname: "/CustomerList",
              });

            } else if (this.state.logintype === "E") {

              this.setState({ loader: true });
              if (res.CanBYPMFA == "N") {
                
                this.setState({ showOTPModal: true });
                this.setState({ initialAttempts: false });
                this.sendOTP(true);
              } else {
                
              this.props.setSessionStateFunc("true");
                this.setState({ initialAttempts: false });
                this.props.history.push({
                  pathname: "/EmployeeList",
                });
                this.setState({ loader: false });
              }

            } else {
             
              this.props.setSessionStateFunc("true");

              if (res.CanBYPMFA == "N") {
                this.setState({ loader: true });
                this.setState({ showOTPModal: true });
                this.sendOTP(true);

              } else {
                
              this.props.setSessionStateFunc("true");
                this.setState({ loader: true });
                this.setState({ initialAttempts: false });
                this.Auth.getCustomerLocation().then(() => {
                  this.Auth.getCustomerAddress().then(() => {
                    this.setState({ loader: true });
                    this.setState({ initialAttempts: false });
                    this.props.history.push({
                      pathname: "/Home",
                    })

                  });
                 
                });
              }
            }
          }
          else {
            this.setState({ loader: false });
            this.setState({ showLoginBox: true, userMessage: 'Userid/password combination is invalid' })
          }
        })
        .catch((err) => {
          this.setState({ loader: false }); 
          this.setState({ showLoginBox: true, userMessage: 'Userid/password combination is invalid' })
        })
        .finally(() => {
          // setInterval(() => {
          //   this.setState({ loader: false });
          // }, 2000);
        });
      {
      }
    }
    else if (!otp) {
      this.setState({ loader: false });
      this.setState({ showLoginBox: true, userMessage: 'Maximum OTP attempts reached try after 5 minutes.' })

    } else {
      this.setState({ loader: false });
      this.setState({ showLoginBox: true, userMessage: 'Maximum Login attempts reached try after 5 Minutes.' })

    }

  }
  render() {
    //Below details has to change once build timestamp identified

    return (
      <div id="loginDiv" style={{ height: "100%" }}>
        {this.state.showLoginBox && (
          <ESSModal
            handle2ndButtonClick={this.handle2ndButtonClick}
            handleClose={this.handleClose}
            btn1Text="Ok"
            userMessage={this.state.userMessage}
            isAlert="true"
            isContentMessage="true"
            show={this.state.showLoginBox}
          />
        )}


        <Modal
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="OTPModal"
          show={this.state.showOTPModal}
          onHide={this.handleOTPButtonClick}
          style={{ marginTop: "-50px", bagroundColor: "white !important" }}
          backdrop={false}
        >
          <Modal.Body style={{ paddingBottom: "0px" }}>
            {!this.state.isMaxAttemptReached ? <>
              <form onSubmit={this.validateOTP}>
                <p style={{ whiteSpace: "pre-wrap", fontWeight: "bold", fontSize: "14px" }}>
                  Enter the OTP
                </p>
                <label className="col-sm-12 form-label">
                  Enter the One-Time Password (OTP) sent to your registered email address.
                </label>
                <center>
                  <input
                    name="txtOTP"
                    type="text"
                    onChange={this.myChangeHandler}
                    maxLength="10" onInput={this.maxLengthCheck} 
                    value={this.state.txtOTP}
                    className="form-control  col-sm-8 col-sm-offset-3"
                    placeholder="Enter OTP"
                    pattern="^[a-zA-Z0-9]+$"
                    required
                    autoComplete="off"
                  />

                </center>

                <label className="col-sm-12 form-label"><br />
                  If you don't see it inbox, please check your spam or junk folder.
                </label>
                {this.state.expired ? <>
                  <label className="col-sm-12 form-label">
                    Didn't Received OTP...... <a href={"#"}   onClick={(e) => this.submit(e)} style={{ fontSize: "15px" }}
                    >Resend OTP!</a>
                  </label>
                </> : <>

                </>}

                <center>
                  <div>
                    {this.state.expired && !this.state.isMaxAttemptReached ? (
                      <p style={{ color: 'red' }}>OTP has expired. Please request a new one.</p>
                    ) : (
                      <p>OTP expires in: <strong>{this.formatTime(this.state.timeLeft)}</strong></p>
                    )}
                  </div>
                </center>
              </form>
            </> : <>
              <label className="col-sm-12 form-label"><br />
              Maximum Login attempts reached try after 5 Minutes..
              </label>
            </>}

          </Modal.Body>
          <Modal.Footer
            style={{ display: "block", justifyContent: "center", border: "0" }}
          >
            <center>
              {!this.state.isMaxAttemptReached && (
                <div className="btn-group col-sm-5 ">

                  <button
                    variant="secondary"
                    className="btn btn-primary btn-sm "
                    centered
                    onClick={this.validateOTP}
                    disabled={this.state.txtOTP == "" || this.state.expired ? true : false}
                  >
                    Submit
                  </button>
                </div>
              )}
              <div className="btn-group col-sm-5 ">
                <button
                  variant="secondary"
                  className="btn btn-secondary btn-sm"
                  centered
                  onClick={this.handleOTPButtonClick}
                >
                  Cancel
                </button>
              </div>
            </center>
          </Modal.Footer>
        </Modal>




        <div className={`${appConstants.isR3App ? "maindivR3" : "maindiv"}`}>
          <h5 className="mainHeading">Self Service</h5>
          <div className="divContainer">
            <form onSubmit={this.submit.bind(this)} id="login-form">
              <div className="divlogin">
                <div className="card">
                  <div
                    className={`${appConstants.isR3App ? "logintitleR3" : "logintitle"
                      }`}
                  >
                    <div className="card-header">
                      <h5 className="card-title">Login</h5>
                    </div>
                  </div>
                  <div
                    className={`${appConstants.isR3App ? "divcardR3" : "divcard"
                      }`}
                  >
                    <div className="card-body card-body_login border-primary">
                      <div>
                        {appConstants.isR3App ? (
                          <a
                            target="_blank"
                            title="Click for Company Home page"
                            href="http://www.r3safety.com/"
                          >
                            <img src={r3Logo} className="logoess" alt="R3" />
                          </a>
                        ) : (
                          <a
                            target="_blank"
                            title="Click for Company Home page"
                            href="http://www.bunzldistribution.com/"
                          >
                            <img
                              src={bunzlLogo}
                              className="logoess"
                              alt="Bunzl"
                            />
                          </a>
                        )}
                        {appConstants.isR3App ? (
                          <label className="bunzltitle">
                            R3 Reliable Redistribution Resource
                          </label>
                        ) : (
                          <label className="bunzltitle">
                            Bunzl Distribution
                          </label>
                        )}
                        <img
                          src={infologo}
                          className="infologo"
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({
                              showLoginBox: true, userMessage: `Customer Self Service\nVersion: ${process.env.REACT_APP_VERSIONUMBER
                                }\nBuild Timestamp: ${new Date().toLocaleString()}\nBuild Number: ${process.env.REACT_APP_VERSIONUMBER
                                }`
                            });
                          }}
                        ></img>
                      </div>

                      <center>
                        <h6>Enter Login Credentials and click login</h6>
                      </center>
                      <div className="loginContent">
                        <div className="form-group row">
                          <label
                            className="col-sm-4 col-form-label"
                            for="loginAs"
                          >
                            Login as
                          </label>
                          <select
                            name="logintype"
                            onChange={this.myChangeHandler}
                            className="form-control card-body_login col-sm-6"
                            id="loginAs"
                          >
                            <option> Customer</option>
                            <option>Employee</option>
                            <option>Customer Group</option>
                          </select>
                        </div>

                        {this.state.showCompanyField ? (
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">
                              Company Number
                            </label>
                            <input
                              type="companyNo"
                              onChange={this.myChangeHandler}
                              name="txtCompanyNumber"
                              type="number"
                              maxLength="2" onInput={this.maxLengthCheck} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                              value={this.state.txtCompanyNumber}
                              className="form-control card-body_login col-sm-6"
                              placeholder="Enter Company Number"
                            />
                          </div>
                        ) : null}

                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">
                            User Id
                          </label>
                          <input
                            type="userId"
                            name="txtUserName"
                            maxLength="15"
                            onChange={this.myChangeHandler}
                            onBlur={this.myChangeHandlerForCust}
                            value={this.state.txtUserName}
                            className="form-control card-body_login col-sm-6"
                            placeholder="Enter User Id"
                          />
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">
                            Password
                          </label>
                          <input
                            type="password"
                            maxLength="10"
                            name="txtPassword"
                            onChange={this.myChangeHandler}
                            value={this.state.txtPassword}
                            className="form-control card-body_login col-sm-6"
                            placeholder="Enter password"
                          />
                        </div>

                        <div>
                          <div className="btn-group col-sm-5 ">
                            <button

                              type="submit"
                              className="btn btn-primary btn-sm"
                              disabled={this.state.loader || !(this.state.txtPassword) || !(this.state.txtUserName) || (!(this.state.txtCompanyNumber) && this.state.logintype === "C")}
                              value={this.state.inputVal}
                            >
                              {this.state.loader ? "Submitting..." : "Submit"}
                            </button>
                          </div>

                          <div className="btn-group col-sm-5 ">
                            <button
                              type="button"
                              onClick={this.cancleLogin}
                              className="btn btn-secondary btn-sm"
                              value={this.state.inputVal}
                              disabled={this.state.loader}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${appConstants.isR3App ? "footercolorR3" : "footercolor"
                      }`}
                  >
                    <div className="card-footer">
                      <div className="row">
                        <div className="col-12">
                          <center>
                            <small className="text-muted">
                              {appConstants.isR3App
                                ? "Copyright" + " " + (new Date().getFullYear()) + "R3 Reliable Redistribution Resource"
                                : "Copyright" + " " + (new Date().getFullYear()) + " Bunzl Distribution"}
                            </small>
                          </center>
                        </div>

                      </div>
                      <div className="row" >
                        <div className="col-12">
                          <center>
                            <small>
                              < a href="https://www.bunzlnalegal.com/privacypolicy" style={{ color: "white" }}>Privacy Policy  |</a>
                              &nbsp;
                              <a href="https://www.bunzlnalegal.com/terms-of-use" style={{ color: "white" }}> Terms of Use  |</a>
                              &nbsp;
                              <a href="https://bunzlnalegal.com/privacypolicy/#california-residents" style={{ color: "white" }}>  California Collection Notice  |</a>
                              &nbsp;
                              <a href="https://bunzlnalegal.com/privacypolicy/#notice-of-right-to-opt-out" style={{ color: "white" }}> Do Not Sell My Info</a>

                            </small></center>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Login);
